import BEIcon from '@molecules/BEIcon';
import Text from '@molecules/Text';
import { forwardRef } from 'react';
import { BEPillsProps } from './BEPillsProps';
import { StyledPills, StyledPillsLabel } from './StyledPills';

/* eslint-disable react/display-name */
const BEPills = forwardRef<HTMLDivElement, BEPillsProps>(
  (
    {
      children,
      iconLeft,
      iconRight,
      iconWeight = 'solid',
      iconSize = 'sm',
      fontSize,
      skin = 'attribute',
    },
    ref
  ) => {
    return (
      <StyledPills skin={skin} ref={ref}>
        {!iconLeft && skin === 'amenity' && (
          <BEIcon name="check" weight={iconWeight} size={iconSize} />
        )}
        {iconLeft && (
          <BEIcon name={iconLeft} weight={iconWeight} size={iconSize} />
        )}
        {fontSize && (
          <Text type="card-body" size={fontSize}>
            {children}
          </Text>
        )}
        {!fontSize && (
          <StyledPillsLabel skin={skin}>{children}</StyledPillsLabel>
        )}
        {iconRight && (
          <BEIcon name={iconRight} weight={iconWeight} size={iconSize} />
        )}
      </StyledPills>
    );
  }
);

export default BEPills;
